import { render, staticRenderFns } from "./ProfileDiligenceData.vue?vue&type=template&id=6cbca0a8&scoped=true&"
import script from "./ProfileDiligenceData.vue?vue&type=script&setup=true&lang=js&"
export * from "./ProfileDiligenceData.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbca0a8",
  null
  
)

export default component.exports